import * as React from "react";
import { Option } from "db";
import { styled } from "theme";
import { Flex, Box } from "@chakra-ui/core";
import Switch from "components/switch/Switch";
import Price from "components/Price";

export interface Props {
  title: string;
  options: Option[];
  selectOption: (index: number) => void;
  clearOptions: () => void;
}

export default function MultiOption({ title, options, selectOption, clearOptions }: Props) {
  const [price, setPrice] = React.useState(options[0].price || 0);

  React.useEffect(() => {
    if (options[0].optional === false) {
      selectOption(0);
    }
  }, []);

  const isChecked = options.reduce((acc, cur) => acc || !!cur.selected, false);

  return (
    <Switch
      isChecked={isChecked}
      isDisabled={options[0].optional === false}
      onChange={(b) => {
        if (b) {
          selectOption(0);
        } else {
          clearOptions();
        }
      }}
    >
      <Box>
        <Flex justifyContent="space-between">
          <PriceContainer>{price !== 0 && <Price active={isChecked} price={price} />}</PriceContainer>
        </Flex>
        <OptionsContainer>
          {options.map((option, n) => (
            <OptionContainer
              key={option.code}
              className={option.selected ? "selected" : "idle"}
              onClick={(e: any) => {
                e.preventDefault();
                if (option.selected) {
                  clearOptions();
                } else {
                  selectOption(n);
                }
                setPrice(option.price || 0);
              }}
            >
              {option.color !== undefined && <ColorCube color={option.color} />}
              {option.name}
            </OptionContainer>
          ))}
        </OptionsContainer>
      </Box>
    </Switch>
  );
}

const OptionsContainer = styled.div`
  display: flex;
  flex: 1 1 auto;

  align-items: center;
  margin-top: 9px;
`;

const OptionContainer = styled.button`
  display: flex;
  align-items: center;
  border-radius: 4px;
  margin: 0 8px 0 0;
  border: 1px solid #ebebeb;
  color: #575757;
  padding: 8px 10px;

  &.selected {
    border-color: ${(props) => props.theme.colors.green["400"]};
    color: ${(props) => props.theme.colors.green["400"]};
  }
`;

const ColorCube = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 3px;
  border: 1px solid #eee;
  background-color: ${(props) => props.color};
`;

const Name = styled.label`
  flex: 1 1 auto;
  padding-right: 10px;
`;

const PriceContainer = styled.div`
  flex: 0 0 80px;
`;
